import type { Filter, FilterKey, Job } from '../../../types';

const fieldHasValue = (jobs: Job[], field: FilterKey) =>
  jobs.some((job) => {
    if (field === 'salary') {
      return job.salary.type !== 'none';
    }
    if (field === 'skills') {
      return job.skills.filter(({ name }) => name.trim()).length;
    }
    return job[field];
  });

export const getActiveFilters = (
  filters: Filter[],
  jobs: Job[],
  t: (str: string) => string
) => {
  const labels = {
    salary: t('Salary'),
    location: t('Location'),
    skills: t('Skills'),
    typeOfContract: t('Type of Contract'),
    company: t('Company'),
    department: t('Department')
  };

  return filters
    .filter((filter) => filter.selected && fieldHasValue(jobs, filter.type))
    .map((filter) => ({
      id: filter.id,
      label: labels[filter.type],
      field: filter.type
    }));
};
